import { PcDriver } from '@acorn-portal/shared/src/services/subscriptionAPI';
import { checkDeepMatch } from '@acorn-portal/shared/src/utils/object-helpers/check-deep-match';

/**
 * Checks if the drivers in the page data are unchanged compared to the original response data.
 * Returns true if all drivers match and the lengths are equal.
 * Typically used on the submission of the Amend Drivers page to prevent unnecessary API calls.
 *
 * @param originalData - Array of original driver objects from the quote response.
 * @param workingData - Array of objects containing driver data from the page.
 * @returns True if drivers are unchanged, false otherwise.
 */
export const areDriversUnchanged = (originalData: PcDriver[], workingData: PcDriver[]): boolean => {
	if (originalData.length !== workingData.length) return false;
	const driverMatches = originalData.map((originalDriver, index) => checkDeepMatch(originalDriver, workingData[index]));
	return driverMatches.every((match) => match);
};
